// import { create } from "zustand";
// import { persist } from "zustand/middleware";

// const useStore = create(
//   persist(
//     (set) => ({
//       user: null,
//       setUser: (user) => set({ user }),
//       clearUser: () => {
//         set({ user: null });
//         useStore.persist.clearStorage();
//       },
//       assigned: null,
//       setAssigned: (assigned) => set({ assigned }),
//       message: null,
//       setMessage: (message) => set({ message }),
//     }),
//     { name: "user-storage" }
//   )
// );

// export default useStore;

import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useStore = create(
  persist(
    (set) => ({


      data: [],
      setData: (data) => set({ data }),
      clearData: () => set({ data: [] }),

      role: null,
      setRole: (role) => set({ role }),

      permissions: [],
      setPermissions: (permissions) => set({ permissions }),
    }),
    {
      name: "service-engineer-storage",
    }
  )
);

export const useTempStore = create((set) => ({
  tempData: {},

  setTempData: (newData) =>
    set((state) => ({
      tempData: { ...state.tempData, ...newData },
    })),

  removeTempKeys: (keys = []) =>
    set((state) => {
      const updated = { ...state.tempData };
      keys.forEach((k) => delete updated[k]);
      return { tempData: updated };
    }),

  clearTempData: () => set({ tempData: {} }),
}));
